/* eslint-disable */

/** InvestmentEntity types offer by Cash */
export enum InvestmentEntityType {
  CURRENCY = "CURRENCY",
  STOCK = "STOCK",
  ETF = "ETF",
}

/** InvestmentEntity status, used to disable a offering */
export enum InvestmentEntityStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/** Used to know if the entity should be displayed on the app. */
export enum InvestmentEntityVisibility {
  /** VISIBLE - Customers should be able to see the investment entity. */
  VISIBLE = "VISIBLE",
  /** INVISIBLE - Customer should not be able to see the investment entity unless they hold it. */
  INVISIBLE = "INVISIBLE",
  /** DECOMMISSIONED - The investment entity is not valid anymore (company closed, merged, etc.). */
  DECOMMISSIONED = "DECOMMISSIONED",
}

/** Used to know if the entity can be traded in our services. */
export enum InvestmentEntityTradability {
  /** UNTRADABLE - Trades are not allowed for this investment entity. */
  UNTRADABLE = "UNTRADABLE",
  /** TRADABLE - Trades are allowed for this investment entity. */
  TRADABLE = "TRADABLE",
  /** SELLABLE - Only sells are allowed for this investment entity. */
  SELLABLE = "SELLABLE",
}

/**
 * InvestmentEntity release, used to identify the stage in the release cycle from upcoming to
 * fully released
 */
export enum InvestmentEntityReleaseStage {
  UNRELEASED = "UNRELEASED",
  PREVIEW_FOR_IPO = "PREVIEW_FOR_IPO",
  RELEASED = "RELEASED",
}

export interface InvestmentEntity {
  /** Unique identifier for a InvestmentEntity. */
  token?: string;
  symbol?: string;
  display_name?: string;
  type?: InvestmentEntityType;
  icon_url?: string;
  total_num_shares?: number;
  status?: InvestmentEntityStatus;
  color?: string;
  visibility?: InvestmentEntityVisibility;
  tradability?: InvestmentEntityTradability;
  /** Timestamp(UTC) of when the IE is first marked as tradable. */
  released_at?: string;
  /** Strictly increasing version of the entity. Used to defend against race conditions. */
  version?: number;
  /** Text that provides an end-user focused description of the entity. */
  about_text?: string;
  /** Keywords, formatted as CSV, that are used as search targets by the client. */
  keywords?: string[];
  /** The CEO of the company. */
  ceo?: string;
  /** The industry that the company operates in. */
  industry?: string;
  /** The company's total number of employees. */
  number_of_employees?: string;
  /** The location of the company's headquarters. */
  headquarters?: string;
  /** darkmode options */
  dark_icon_url?: string;
  dark_color?: string;
  /** Timestamp when Drivewealth reports the instrument to be activated */
  dw_activated_at?: string;
  /** Timestamp when market-prices first returns a valid price for the entity */
  first_price_available_at?: string;
  /** Stage of the IE in the release cycle */
  release_stage?: InvestmentEntityReleaseStage;
  full_security_name?: string;
  cusip?: string;
  /** The year in which a company or an ETF was launched. */
  year_founded?: string;
}

/**
 * An announcement for an investment entity, for example, that the stock will be closed for trading
 * due to a stock split.
 */
export interface InvestmentEntityAnnouncement {
  /** Announcement publication time in milliseconds since the unix epoch. */
  published_at?: number;
  /** Short title for this announcement. */
  title?: string;
  /** Detailed content for the announcement. */
  content?: string;
}

export interface InvestmentEntityCategoryEntry {
  /** Investment Entity token of discovery category item. */
  investment_entity_token?: string;
}

export interface InvestmentEntityCategory {
  /** Name of discovery category. e.g.: "Highest Volume", "Biggest Movers". */
  name?: string;
  /** List of investment entities in category. */
  investment_entities?: InvestmentEntityCategoryEntry[];
  /** High level description of discovery category. */
  description?: string;
  /** Should be considered true if the value isn't set. */
  in_search_suggestion?: boolean;
}
